import * as actionTypes from '@store/filter/action-types';

import ApiClient from '@lib/apiClient';

import { _getKey } from '@utils/Util';

export const toggleFilterItem = (item) => async (dispatch) => {
	dispatch({
		type: actionTypes.TOGGLE_FILTER_ITEM,
		payload: item
	});
};

export const createOrUpdateFilterItem = (item) => async (dispatch) => {
	dispatch({
		type: actionTypes.CREATE_OR_UPDATE_FILTER_ITEM,
		payload: item
	});
};
export const getAllFilterData = () => async (dispatch) => {
	dispatch({
		type: actionTypes.GET_ALL_FILTERS
	});
};

export const toggleShowFilter = () => async (dispatch) => {
	dispatch({
		type: actionTypes.TOGGLE_SHOW_FILTER
	});
};

export const clearAllFilters = () => async (dispatch) => {
	dispatch({
		type: actionTypes.CLEAR_ALL_FILTERS
	});
};

export const getRoles = () => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getRolesV2', '?page=0&size=60');
		dispatch({
			type: actionTypes.FETCH_FILTER_DATA,
			payload: {
				key: 'roleList',
				data: response.data.map((item) => {
					item._key = _getKey();
					return item;
				})
			}
		});
	} catch {
		//console.log('Error', error);
		dispatch({ type: actionTypes.FETCH_FILTER_DATA_FAILURE });
	}
};

export const getUserTypes =
	(isWithoutBuyer = false) =>
	async (dispatch) => {
		try {
			const response = await ApiClient.GET(
				'getUserTypesWithBuyer',
				`?isWithoutBuyer=${isWithoutBuyer}`
			);
			dispatch({
				type: actionTypes.FETCH_FILTER_DATA,
				payload: {
					key: 'userTypeList',
					data: response.data.map((item) => ({
						value: item.value,
						label: item.label,
						_key: _getKey()
					}))
				}
			});
		} catch {
			//console.log('Error', error);
			dispatch({ type: actionTypes.FETCH_FILTER_DATA_FAILURE });
		}
	};

export const getStatus = () => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getStatus');
		dispatch({
			type: actionTypes.FETCH_FILTER_DATA,
			payload: {
				key: 'statusList',
				data: response.data.map((item) => {
					item.name = item.value;
					item.constant = item.key;
					return item;
				})
			}
		});
	} catch {
		//console.log('Error', error);
		dispatch({ type: actionTypes.FETCH_FILTER_DATA_FAILURE });
	}
};

export const getProjectManagers = () => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getProjectUserSuggestions', '?userType=PROJECT_MANAGER');
		dispatch({
			type: actionTypes.FETCH_FILTER_DATA,
			payload: {
				key: 'projectManagerList',
				data: response.data.map((item) => {
					item._key = _getKey();
					return item;
				})
			}
		});
	} catch {
		//console.log('Error', error);
		dispatch({ type: actionTypes.FETCH_FILTER_DATA_FAILURE });
	}
};

export const getAccountManagers = () => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getProjectUserSuggestions', '?userType=ACCOUNT_MANAGER');
		dispatch({
			type: actionTypes.FETCH_FILTER_DATA,
			payload: {
				key: 'accountManagerList',
				data: response.data.map((item) => {
					item._key = _getKey();
					return item;
				})
			}
		});
	} catch {
		//console.log('Error', error);
		dispatch({ type: actionTypes.FETCH_FILTER_DATA_FAILURE });
	}
};

export const getDesignStages = () => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getEnums', 'info.nitex.app.common.enums.AvailabilityStatus');
		dispatch({
			type: actionTypes.FETCH_FILTER_DATA,
			payload: {
				key: 'designStageList',
				data: response.data.map((item) => {
					item.label = item.name;
					item.value = item.constant;
					item._key = _getKey();
					return item;
				})
			}
		});
	} catch {
		//console.log('Error', error);
		dispatch({ type: actionTypes.FETCH_FILTER_DATA_FAILURE });
	}
};

export const getSeasonList = () => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getEnums', 'info.nitex.app.materials.Season');
		dispatch({
			type: actionTypes.FETCH_FILTER_DATA,
			payload: {
				key: 'seasonList',
				data: response.data.map((item) => {
					item.label = item.name;
					item.value = item.constant;
					item._key = _getKey();
					return item;
				})
			}
		});
	} catch {
		//console.log('Error', error);
		dispatch({ type: actionTypes.FETCH_FILTER_DATA_FAILURE });
	}
};

export const getProductGroups = () => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getProductGroup');
		dispatch({
			type: actionTypes.FETCH_FILTER_DATA,
			payload: {
				key: 'productGroupList',
				data: response.data.map((item) => {
					item._key = _getKey();
					return item;
				})
			}
		});
	} catch {
		//console.log('Error', error);
		dispatch({ type: actionTypes.FETCH_FILTER_DATA_FAILURE });
	}
};

export const getFabricTypes = () => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getEnums', 'info.nitex.app.materials.FabricType');
		dispatch({
			type: actionTypes.FETCH_FILTER_DATA,
			payload: {
				key: 'fabricTypeList',
				data: response.data.map((item) => {
					item.label = item.name;
					item.value = item.constant;
					item._key = _getKey();
					return item;
				})
			}
		});
	} catch {
		//console.log('Error', error);
		dispatch({ type: actionTypes.FETCH_FILTER_DATA_FAILURE });
	}
};

export const getMaterialCompositions = () => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getEnums', 'info.nitex.app.materials.MaterialComposition');
		dispatch({
			type: actionTypes.FETCH_FILTER_DATA,
			payload: {
				key: 'materialCompositionList',
				data: response.data.map((item) => {
					item.label = item.name;
					item.value = item.constant;
					item._key = _getKey();
					return item;
				})
			}
		});
	} catch {
		//console.log('Error', error);
		dispatch({ type: actionTypes.FETCH_FILTER_DATA_FAILURE });
	}
};

export const getMyCollections = () => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getMyCollections', '?page=0&size=1000');
		dispatch({
			type: actionTypes.FETCH_FILTER_DATA,
			payload: {
				key: 'myCollectionList',
				data: response.data.data.map((item) => {
					item._key = _getKey();
					return item;
				})
			}
		});
	} catch {
		//console.log('Error', error);
		dispatch({ type: actionTypes.FETCH_FILTER_DATA_FAILURE });
	}
};

export const getBrandList = () => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getBrandBasicList', '?page=0&size=1000');
		dispatch({
			type: actionTypes.FETCH_FILTER_DATA,
			payload: {
				key: 'brandList',
				data: response.data.data.map((item) => {
					item._key = _getKey();
					return item;
				})
			}
		});
	} catch {
		//console.log('Error', error);
		dispatch({ type: actionTypes.FETCH_FILTER_DATA_FAILURE });
	}
};

export const getCollectionPrivacyList = () => async (dispatch) => {
	dispatch({
		type: actionTypes.FETCH_FILTER_DATA,
		payload: {
			key: 'collectionPrivacyList',
			data: [
				{ label: 'Public', value: 'PUBLIC', _key: _getKey() },
				{ label: 'Only me', value: 'ONLY_ME', _key: _getKey() },
				{ label: 'User type', value: 'USER_TYPE', _key: _getKey() },
				{ label: 'Custom', value: 'CUSTOM', _key: _getKey() }
			]
		}
	});
};

export const getOrderStatusList = () => async (dispatch) => {
	dispatch({
		type: actionTypes.FETCH_FILTER_DATA,
		payload: {
			key: 'orderStatusList',
			data: [
				{ label: 'Pending', value: 'PENDING', _key: _getKey() },
				{ label: 'Running', value: 'RUNNING', _key: _getKey() },
				{ label: 'Completed', value: 'COMPLETED', _key: _getKey() }
			]
		}
	});
};

export const getTaskStatusList = () => async (dispatch) => {
	dispatch({
		type: actionTypes.FETCH_FILTER_DATA,
		payload: {
			key: 'taskStatusList',
			data: [
				{ label: 'Pending', value: 'PENDING', _key: _getKey() },
				{ label: 'Completed', value: 'COMPLETED', _key: _getKey() },
				{ label: 'Approved', value: 'APPROVED', _key: _getKey() }
			]
		}
	});
};

export const getQuoteStatusList = () => async (dispatch) => {
	dispatch({
		type: actionTypes.FETCH_FILTER_DATA,
		payload: {
			key: 'quoteStatusList',
			data: [
				{ label: 'Offer Pending', value: 'OFFER_PENDING', _key: _getKey() },
				{ label: 'Quoted', value: 'PRICE_GIVEN', _key: _getKey() },
				{ label: 'Product Sold', value: 'PRODUCT_SOLD', _key: _getKey() },
				{ label: 'Order Placed', value: 'ORDER_PLACED', _key: _getKey() }
			]
		}
	});
};

export const getCollectionOwners = () => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getCollectionOwners');
		//console.log('Error', response);
		dispatch({
			type: actionTypes.FETCH_FILTER_DATA,
			payload: {
				key: 'collectionOwnerList',
				data: response.data.map((item) => {
					item._key = _getKey();
					return item;
				})
			}
		});
	} catch {
		//console.log('Error', error);
		dispatch({ type: actionTypes.FETCH_FILTER_DATA_FAILURE });
	}
};

export const getTaskFilters = () => async (dispatch) => {
	await ApiClient.GET('allTaskFilterOptions', '?orderStatus=RUNNING')
		.then(({ data }) => {
			let result = {
				memberOptions: data.memberList.map((item) => {
					return {
						value: item.memberId,
						label: item.memberName,
						_key: _getKey()
					};
				}),
				stageOptions: data.distinctStageNames.map((item) => {
					return {
						value: item,
						label: item,
						_key: _getKey()
					};
				}),
				orderOptions: data.orderResponseList.map((item) => {
					return {
						value: item.orderId,
						label: item.name,
						_key: _getKey()
					};
				}),
				styleOptions: data.orderProductList.map((item) => {
					return {
						value: item.id,
						label: item.name,
						_key: _getKey()
					};
				}),
				brandOptions: data.brandResponseList.map((item) => {
					return {
						value: item.id,
						label: item.name,
						_key: _getKey()
					};
				})
			};
			dispatch({
				type: actionTypes.FETCH_FILTER_DATA,
				payload: {
					key: 'taskMemberList',
					data: result.memberOptions
				}
			});
			dispatch({
				type: actionTypes.FETCH_FILTER_DATA,
				payload: {
					key: 'taskStageNamesList',
					data: result.stageOptions
				}
			});
			dispatch({
				type: actionTypes.FETCH_FILTER_DATA,
				payload: {
					key: 'taskOrderProductList',
					data: result.styleOptions
				}
			});
			dispatch({
				type: actionTypes.FETCH_FILTER_DATA,
				payload: {
					key: 'taskOrderList',
					data: result.orderOptions
				}
			});
			dispatch({
				type: actionTypes.FETCH_FILTER_DATA,
				payload: {
					key: 'taskBrandList',
					data: result.brandOptions
				}
			});
		})
		.catch(() => {
			//console.log('Error', response);
			dispatch({ type: actionTypes.FETCH_FILTER_DATA_FAILURE });
		});
};

export const getInvoiceStatusList = () => async (dispatch) => {
	dispatch({
		type: actionTypes.FETCH_FILTER_DATA,
		payload: {
			key: 'invoiceStatusList',
			data: [
				{ label: 'Pending', value: 'PENDING', _key: _getKey() },
				{ label: 'Partially paid', value: 'PARTIALLY_PAID', _key: _getKey() },
				{ label: 'Paid', value: 'PAID', _key: _getKey() }
			]
		}
	});
};

export const getIsNitexProductOptions = () => async (dispatch) => {
	dispatch({
		type: actionTypes.FETCH_FILTER_DATA,
		payload: {
			key: 'isNitexProductOptions',
			data: [
				{ key: true, value: 'Yes' },
				{ key: false, value: 'No' }
			]
		}
	});
};

export const setShowItemsCount = (isShow) => async (dispatch) => {
	dispatch({
		type: actionTypes.IS_SHOW_ITEMS_COUNT,
		payload: isShow
	});
};
